/**
 * StatusPipeline — Auftragsstatus der Bestellungen im Zeitraum als
 * gestapelter Balken + Legende. Farben nur semantisch / Navy-Abstufung.
 */
import { Panel, PanelSkeleton } from './Panel';
import { num } from './format';

const COLORS = {
  Neu: '#1D4ED8',
  Kommissioniert: '#1E3A8A',
  Versandbereit: '#334155',
  Unterwegs: '#64748B',
  Geliefert: '#059669',
  Berechnet: '#047857',
  Abgeschlossen: '#94A3B8',
  Storniert: '#DC2626',
};

export default function StatusPipeline({ loading, rows }) {
  const total = rows.reduce((s, r) => s + r.count, 0);
  const shown = rows.filter((r) => r.count > 0);

  return (
    <Panel overline="Bestellungen im Zeitraum" title="Auftragsstatus" meta={!loading && <span className="text-xs text-slate-400 tabular-nums">{num(total)} gesamt</span>}>
      {loading ? (
        <PanelSkeleton rows={3} />
      ) : total === 0 ? (
        <p className="text-sm text-slate-400 py-4">Keine Bestellungen im Zeitraum.</p>
      ) : (
        <>
          <div className="flex h-2.5 w-full overflow-hidden rounded-full bg-slate-100" role="img" aria-label="Statusverteilung">
            {shown.map((r) => (
              <span key={r.status} style={{ width: `${(r.count / total) * 100}%`, background: COLORS[r.status] }} />
            ))}
          </div>
          <dl className="mt-4 grid grid-cols-2 gap-x-4 gap-y-2">
            {shown.map((r) => (
              <div key={r.status} className="flex items-center justify-between gap-2 text-sm">
                <dt className="flex items-center gap-2 text-slate-600 min-w-0">
                  <span className="w-2 h-2 rounded-full shrink-0" style={{ background: COLORS[r.status] }} />
                  <span className="truncate">{r.status}</span>
                </dt>
                <dd className="font-semibold text-slate-900 tabular-nums">{num(r.count)}</dd>
              </div>
            ))}
          </dl>
        </>
      )}
    </Panel>
  );
}
